import React, { useState, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import VideoCard from '../components/VideoCard';
import { youtubeService } from '../services/youtubeService';
import './SearchResults.css';

const SearchResults = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q');
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  const searchVideos = useCallback(async () => {
    setLoading(true);
    const results = await youtubeService.searchVideos(query);
    setVideos(results);
    setLoading(false);
  }, [query]);

  useEffect(() => {
    if (query) {
      searchVideos();
    }
  }, [query, searchVideos]);

  return (
    <div className="search-results">
      <h2 className="search-title">Search results for: "{query}"</h2>
      
      {loading ? (
        <div className="loading">
          <div className="spinner"></div>
          <p>Searching...</p>
        </div>
      ) : (
        <div className="video-grid">
          {videos.length > 0 ? (
            videos.map((video, index) => (
              <div 
                key={video.id.videoId}
                style={{ animationDelay: `${index * 0.05}s` }}
                className="video-grid-item"
              >
                <VideoCard video={video} />
              </div>
            ))
          ) : (
            <div className="no-results">
              <div className="no-results-icon">
                <svg viewBox="0 0 24 24" width="80" height="80" fill="currentColor">
                  <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                </svg>
              </div>
              <h3>No videos found</h3>
              <p>Try different keywords or check your spelling</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchResults;
